import { useCallback } from "react";

import { LookerEmbedSDK } from "@looker/embed-sdk";

import { useHub } from "data/hub/useHub";
import { generateLookerEmbedSDKParams } from "data/libs/insights";

export function useEmbedInsight(insightId) {
  const { hubId } = useHub();

  const embedInsight = useCallback(
    async (el) => {
      if (el) {
        el.innerHTML = "";

        const { host, config } = await generateLookerEmbedSDKParams(hubId);

        LookerEmbedSDK.init(host, config);

        LookerEmbedSDK.createDashboardWithId(insightId)
          .appendTo(el)
          .build()
          .connect()
          .catch(() => {
            el.textContent =
              "The insight is not available at the moment. Please contact support for assistance.";
          });
      }
    },
    [hubId, insightId]
  );

  return { embedInsight };
}

export default useEmbedInsight;
